"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "w-full 2xl:container mx-auto p-4 flex flex-col" };
const _hoisted_2 = { class: "filters justify-between lg:items-end print:hidden" };
const _hoisted_3 = { class: "flex flex-col md:flex-row gap-4" };
const _hoisted_4 = {
    key: 0,
    class: "flex flex-col w-full justify-center"
};
const _hoisted_5 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, " ", -1);
const _hoisted_6 = { class: "flex flex-col md:flex-row gap-4" };
const _hoisted_7 = {
    key: 0,
    class: "flex border rounded-lg p-3 bg-white shadow print:hidden"
};
const _hoisted_8 = { class: "mr-2" };
const _hoisted_9 = { class: "flex md:justify-end grow" };
const _hoisted_10 = { class: "flex items-center justify-center gap-2 font-bold" };
const _hoisted_11 = { class: "text-center font-bold" };
const _hoisted_12 = ["onClick"];
const _hoisted_13 = ["onClick"];
const _hoisted_14 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_15 = { class: "text-center" };
const _hoisted_16 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_17 = { class: "text-center" };
const _hoisted_18 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_19 = { class: "text-center" };
const _hoisted_20 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_21 = { class: "text-center" };
const _hoisted_22 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_23 = { class: "text-center" };
const _hoisted_24 = { class: "flex flex-row gap-1 justify-center items-center print:hidden" };
const _hoisted_25 = ["onClick"];
const vue_3 = require("vue");
const i18n_1 = require("../../common/i18n");
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
const ShopInput_vue_1 = __importDefault(require("../../components/Form/ShopInput.vue"));
const Modal_vue_1 = __importDefault(require("../../components/Modal.vue"));
const OrderItems_vue_1 = __importDefault(require("./OrderItems.vue"));
const OrderDeliveryInfos_vue_1 = __importDefault(require("./OrderDeliveryInfos.vue"));
const OrderTrackingInfos_vue_1 = __importDefault(require("./OrderTrackingInfos.vue"));
const Toggle_vue_1 = __importDefault(require("../../components/Form/Toggle.vue"));
const shop_1 = require("../../common/utils/shop");
const toastStore_1 = require("../../stores/toast/toastStore");
const securityStore_1 = require("../../stores/security/securityStore");
const PermissionEnum_1 = require("../../models/permission/PermissionEnum");
const ordersStore_1 = require("../../stores/orders/ordersStore");
const vue_router_1 = require("vue-router");
const ShopConfig_1 = require("../../common/utils/ShopConfig");
exports.default = (0, vue_1.defineComponent)({
    __name: 'Orders',
    setup(__props) {
        var _a, _b, _c, _d, _e, _f;
        const router = (0, vue_router_1.useRouter)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const ordersStore = (0, ordersStore_1.useOrdersStore)();
        const currentUser = (0, vue_3.computed)(() => {
            return securityStore.authenticatedUser;
        });
        const orders = (0, vue_3.computed)(() => ordersStore.orders);
        const selectedOrder = (0, vue_3.ref)(null);
        const defaultFilterStartDate = (0, vue_3.computed)(() => {
            let halfYearBeforeToday = new Date();
            halfYearBeforeToday.setMonth(halfYearBeforeToday.getMonth() - 6);
            return (0, shop_1.formatDate)(halfYearBeforeToday);
        });
        const defaultFilterEndDate = (0, vue_3.computed)(() => {
            return (0, shop_1.formatDate)(new Date());
        });
        const orderItemsModalIsOpen = (0, vue_3.ref)(false);
        const orderDeliveryInfosModalIsOpen = (0, vue_3.ref)(false);
        const orderTrackingModalIsOpen = (0, vue_3.ref)(false);
        const trackingDataLoading = (0, vue_3.ref)(false);
        const trackingData = (0, vue_3.ref)([]);
        const uniqueTrackingData = (0, vue_3.computed)(() => {
            if (!trackingData.value || !Array.isArray(trackingData.value) || trackingData.value.length === 0) {
                return [];
            }
            // Erre azért van szükség, mert egy axOrderId-hoz több azonos státusz is tartozhat ugyanazzal az időbélyeggel
            // Ezért csak az egyedi kombinációkat tartjuk meg
            const seen = new Set();
            return trackingData.value.filter((item) => {
                const key = `${item.packingSlipId}-${item.axaptaOrderId}-${item.status}-${item.timeStamp}`;
                if (seen.has(key)) {
                    return false;
                }
                seen.add(key);
                return true;
            });
        });
        const filter = (0, vue_3.ref)({
            startDate: defaultFilterStartDate.value,
            endDate: defaultFilterEndDate.value,
            orderIdPartial: "",
            containOnlyTransferred: false,
        });
        const transferOrdersReportEmail = (0, vue_3.ref)("");
        const orderListFields = (0, vue_3.ref)([
            {
                key: "id",
                label: (_a = (0, i18n_1.trans)("id_order_list", "ID", "orders")) !== null && _a !== void 0 ? _a : "ID",
                value: "id",
            },
            {
                key: "date",
                label: (_b = (0, i18n_1.trans)("date_order_list", "Date", "orders")) !== null && _b !== void 0 ? _b : "Date",
                value: "date",
            },
            {
                key: "status",
                label: (_c = (0, i18n_1.trans)("status_order_list", "Status", "orders")) !== null && _c !== void 0 ? _c : "Status",
                value: "status",
            },
            {
                key: "site",
                label: (_d = (0, i18n_1.trans)("site_order_list", "Site", "orders")) !== null && _d !== void 0 ? _d : "Site",
                value: "site",
            },
            {
                key: "quantity",
                label: (_e = (0, i18n_1.trans)("quantity_order_list", "Quantity", "orders")) !== null && _e !== void 0 ? _e : "Quantity",
                value: "quantity",
            },
            {
                key: "netAmount",
                label: (_f = (0, i18n_1.trans)("net_amount_order_list", "Net Amount", "orders")) !== null && _f !== void 0 ? _f : "Net Amount",
                value: "netAmount",
            },
            {
                key: "actions",
                label: "",
            },
        ]);
        const printPage = () => {
            window.print();
        };
        const queryOrders = async () => {
            var _a;
            if (securityStore.authenticatedUser === null) {
                toastStore.addErrorToast((_a = (0, i18n_1.trans)("no_authenticated_user", "There is no authenticated user", "orders")) !== null && _a !== void 0 ? _a : "There is no authenticated user");
                return;
            }
            if (filter.value.startDate === "") {
                filter.value.startDate = defaultFilterStartDate.value;
            }
            if (filter.value.endDate === "") {
                filter.value.endDate = defaultFilterEndDate.value;
            }
            try {
                await ordersStore.getOrders(router, filter.value, securityStore.authenticatedUser.customer.id);
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const viewOrderItems = async (order) => {
            var _a;
            if (securityStore.authenticatedUser === null) {
                toastStore.addErrorToast((_a = (0, i18n_1.trans)("no_authenticated_user", "There is no authenticated user", "orders")) !== null && _a !== void 0 ? _a : "There is no authenticated user");
                return;
            }
            selectedOrder.value = order;
            ordersStore.resetOrderItems();
            try {
                await ordersStore.getOrderItems(router, {
                    customerId: securityStore.authenticatedUser.customer.id,
                    orderId: order.id,
                });
                const items = ordersStore.orderItems;
                if (items.openedItems.length === 0 &&
                    items.billedItems.length === 0 &&
                    items.billedItemsInfo === null &&
                    items.shippedItems.length === 0) {
                    return;
                }
                orderItemsModalIsOpen.value = true;
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const viewOrderDeliveryInfos = async (order) => {
            var _a;
            if (securityStore.authenticatedUser === null) {
                toastStore.addErrorToast((_a = (0, i18n_1.trans)("no_authenticated_user", "There is no authenticated user", "orders")) !== null && _a !== void 0 ? _a : "There is no authenticated user");
                return;
            }
            selectedOrder.value = order;
            ordersStore.resetOrderDeliveryInfos();
            try {
                await ordersStore.getOrderDeliveryInfos(router, {
                    customerId: securityStore.authenticatedUser.customer.id,
                    orderId: order.id,
                });
                orderDeliveryInfosModalIsOpen.value = true;
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const viewOrderTracking = async (order) => {
            var _a;
            // Ha van deliveryShipmentId, akkor bekerült a rendelés a deliverybe -> tracking elérhető
            if (order.deliveryShipmentId) {
                selectedOrder.value = order;
                orderTrackingModalIsOpen.value = true;
                trackingDataLoading.value = true;
                try {
                    const deliveryManagerApiUrl = ShopConfig_1.ShopConfig.getDeliveryManagerApiUrl();
                    const response = await fetch(`${deliveryManagerApiUrl}/packing-slip-items/status-list?axOrderId=${order.id}`, {
                        method: 'GET',
                        credentials: 'include'
                    });
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    const data = await response.json();
                    trackingData.value = normalizeTrackingData(data);
                }
                catch (error) {
                    console.error('Tracking error:', error);
                    toastStore.addErrorToast((_a = (0, i18n_1.trans)("tracking_data_load_error", "Failed to load tracking data", "orders")) !== null && _a !== void 0 ? _a : "Failed to load tracking data");
                }
                finally {
                    trackingDataLoading.value = false;
                }
            }
        };
        const sendTransferredOrdersReportInEmail = async () => {
            var _a, _b;
            if (securityStore.authenticatedUser === null) {
                toastStore.addErrorToast((_a = (0, i18n_1.trans)("no_authenticated_user", "There is no authenticated user", "orders")) !== null && _a !== void 0 ? _a : "There is no authenticated user");
                return;
            }
            if (confirm((_b = (0, i18n_1.trans)("send_transferred_orders_report_confirm", `Are you really want to send transferred orders report to {email}`, "orders", { email: transferOrdersReportEmail.value })) !== null && _b !== void 0 ? _b : `Are you really want to send transferred orders report to ${transferOrdersReportEmail.value}`)) {
                try {
                    await ordersStore.sendTransferredOrdersReportInEmail(router, {
                        customerId: securityStore.authenticatedUser.customer.id,
                        startDate: filter.value.startDate,
                        endDate: filter.value.endDate,
                        email: transferOrdersReportEmail.value,
                    });
                    toastStore.addToast({
                        message: (0, i18n_1.trans)("email_is_sent_successfully", "Email is sent successfully!", "orders"),
                        type: "success",
                        timer: 5,
                    });
                }
                catch (error) {
                    toastStore.addErrorToast(error.toString());
                }
            }
        };
        const normalizeTrackingData = (data) => {
            const statusMap = {
                'WAIT_FOR_LOAD': (0, i18n_1.trans)('waiting_for_load_status', 'WAITING FOR LOAD', 'orders'),
                'WAITING': (0, i18n_1.trans)('delivering_status', 'DELIVERING', 'orders'),
                'DELIVERED': (0, i18n_1.trans)('delivered_status', 'DELIVERED', 'orders'),
                'REJECTED': (0, i18n_1.trans)('rejected_status', 'REJECTED', 'orders'),
                'NOT_AVAILABLE': (0, i18n_1.trans)('not_available_status', 'NOT AVAILABLE', 'orders'),
            };
            return data.map((item) => ({
                ...item,
                status: statusMap[item.status] || item.status
            }));
        };
        (0, vue_3.onBeforeMount)(() => {
            ordersStore.reset();
        });
        (0, vue_3.watchEffect)(() => {
            if (securityStore.authenticatedUser !== null) {
                transferOrdersReportEmail.value = securityStore.authenticatedUser.email;
            }
        });
        return (_ctx, _cache) => {
            var _a, _b;
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('start_date_placeholder', 'Start Date', 'orders'),
                            label: (0, vue_2.unref)(i18n_1.trans)('start_date_label', 'Start Date', 'orders'),
                            modelValue: filter.value.startDate,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((filter.value.startDate) = $event)),
                            class: "order-filter-input",
                            type: "date",
                            required: "",
                            border: ""
                        }, null, 8, ["placeholder", "label", "modelValue"]),
                        (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('end_date_placeholder', 'End Date', 'orders'),
                            label: (0, vue_2.unref)(i18n_1.trans)('end_date_label', 'End Date', 'orders'),
                            modelValue: filter.value.endDate,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((filter.value.endDate) = $event)),
                            class: "order-filter-input",
                            type: "date",
                            required: "",
                            border: ""
                        }, null, 8, ["placeholder", "label", "modelValue"]),
                        (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('order_id_placeholder', 'e.g.: VR2698758', 'orders'),
                            label: (0, vue_2.unref)(i18n_1.trans)('order_id_label', 'Order ID Partial', 'orders'),
                            modelValue: filter.value.orderIdPartial,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((filter.value.orderIdPartial) = $event)),
                            class: "order-filter-input",
                            type: "text",
                            required: "",
                            border: ""
                        }, null, 8, ["placeholder", "label", "modelValue"]),
                        (!((_a = (0, vue_2.unref)(currentUser)) === null || _a === void 0 ? void 0 : _a.hasPermission((0, vue_2.unref)(PermissionEnum_1.CustomerPermissionEnum).EXPORT_PARTNER)))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_4, [
                                _hoisted_5,
                                (0, vue_2.createVNode)(Toggle_vue_1.default, {
                                    modelValue: filter.value.containOnlyTransferred,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((filter.value.containOnlyTransferred) = $event)),
                                    reversed: "",
                                    label: (0, vue_2.unref)(i18n_1.trans)('only_transferred', 'Only Transferred', 'orders')
                                }, null, 8, ["modelValue", "label"])
                            ]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_6, [
                        (0, vue_2.createElementVNode)("button", {
                            class: "btn btn-rounded btn-warning h-[48px]",
                            onClick: _cache[4] || (_cache[4] = ($event) => (printPage()))
                        }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("print", "Print", "customer_product_return_list")), 1),
                        (0, vue_2.createElementVNode)("button", {
                            class: "btn btn-rounded btn-primary h-[48px]",
                            onClick: queryOrders
                        }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("submit_query", "Submit Query", "orders")), 1)
                    ])
                ]),
                ((0, vue_2.unref)(orders).length > 0 && !((_b = (0, vue_2.unref)(currentUser)) === null || _b === void 0 ? void 0 : _b.hasPermission((0, vue_2.unref)(PermissionEnum_1.CustomerPermissionEnum).EXPORT_PARTNER)))
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, [
                        (0, vue_2.createElementVNode)("div", _hoisted_8, [
                            (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                modelValue: transferOrdersReportEmail.value,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((transferOrdersReportEmail).value = $event)),
                                type: "email",
                                required: "",
                                border: ""
                            }, null, 8, ["modelValue"])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_9, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "self-center btn btn-rounded btn-primary",
                                onClick: sendTransferredOrdersReportInEmail
                            }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("sending_only_transferred_orders_report_in_email", "Sending only transferred orders report in email", "orders")), 1)
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true),
                ((0, vue_2.unref)(orders).length > 0)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ResponsiveTable_vue_1.default, {
                        key: 1,
                        fields: orderListFields.value,
                        "onUpdate:fields": _cache[6] || (_cache[6] = ($event) => ((orderListFields).value = $event)),
                        items: (0, vue_2.unref)(orders),
                        striped: "",
                        condensed: "",
                        panel: ""
                    }, {
                        "head-id": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_10, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("id", "ID", "orders")), 1)
                        ]),
                        "cell-id": (0, vue_2.withCtx)(({ item: order }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_11, [
                                (order.deliveryShipmentId && order.deliveryShipmentId !== '')
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                        key: 0,
                                        class: "icon marso-icon-filled_truck cursor-pointer",
                                        onClick: ($event) => (viewOrderTracking(order))
                                    }, null, 8, _hoisted_12))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (order.shippable)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                        key: 1,
                                        class: "icon marso-icon-filled_truck cursor-pointer",
                                        onClick: ($event) => (viewOrderDeliveryInfos(order))
                                    }, null, 8, _hoisted_13))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(order.id), 1)
                            ])
                        ]),
                        "head-date": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_14, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("date", "Date", "orders")), 1)
                        ]),
                        "cell-date": (0, vue_2.withCtx)(({ item: order }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_15, (0, vue_2.toDisplayString)(order.date), 1)
                        ]),
                        "head-status": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_16, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("status", "Status", "orders")), 1)
                        ]),
                        "cell-status": (0, vue_2.withCtx)(({ item: order }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_17, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)(order.status, order.status, "orders")), 1)
                        ]),
                        "head-site": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_18, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("site", "Site", "orders")), 1)
                        ]),
                        "cell-site": (0, vue_2.withCtx)(({ item: order }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_19, (0, vue_2.toDisplayString)(order.siteId) + " " + (0, vue_2.toDisplayString)(order.siteName), 1)
                        ]),
                        "head-quantity": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_20, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("quantity", "Quantity", "orders")), 1)
                        ]),
                        "cell-quantity": (0, vue_2.withCtx)(({ item: order }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_21, (0, vue_2.toDisplayString)(order.quantity), 1)
                        ]),
                        "head-netAmount": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_22, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("net_amount", "Net Amount", "orders")), 1)
                        ]),
                        "cell-netAmount": (0, vue_2.withCtx)(({ item: order }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_23, (0, vue_2.toDisplayString)(order.formattedNetAmount), 1)
                        ]),
                        "cell-actions": (0, vue_2.withCtx)(({ item: order }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_24, [
                                (0, vue_2.createElementVNode)("button", {
                                    class: "btn btn-rounded btn-primary btn-link",
                                    onClick: ($event) => (viewOrderItems(order))
                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("view_order_items", "View Order Items", "orders")), 9, _hoisted_25)
                            ])
                        ]),
                        _: 1
                    }, 8, ["fields", "items"]))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.createVNode)(Modal_vue_1.default, {
                    isOpen: orderItemsModalIsOpen.value,
                    title: selectedOrder.value !== null
                        ? (0, vue_2.unref)(i18n_1.trans)('view_order_items_modal_title', 'View Order - Order ID: {id}', 'orders', { id: selectedOrder.value.id })
                        : '',
                    onClose: _cache[7] || (_cache[7] = ($event) => (orderItemsModalIsOpen.value = false))
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createVNode)(OrderItems_vue_1.default)
                    ]),
                    _: 1
                }, 8, ["isOpen", "title"]),
                (0, vue_2.createVNode)(Modal_vue_1.default, {
                    isOpen: orderDeliveryInfosModalIsOpen.value,
                    title: selectedOrder.value !== null
                        ? (0, vue_2.unref)(i18n_1.trans)('view_order_delivery_infos_modal_title', 'View Order Delivery Infos - Order ID: {id}', 'orders', { id: selectedOrder.value.id })
                        : '',
                    onClose: _cache[8] || (_cache[8] = ($event) => (orderDeliveryInfosModalIsOpen.value = false))
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createVNode)(OrderDeliveryInfos_vue_1.default)
                    ]),
                    _: 1
                }, 8, ["isOpen", "title"]),
                (0, vue_2.createVNode)(Modal_vue_1.default, {
                    isOpen: orderTrackingModalIsOpen.value,
                    title: selectedOrder.value !== null
                        ? (0, vue_2.unref)(i18n_1.trans)('view_order_tracking_modal_title', 'Order Tracking - Order ID: {id}', 'orders', { id: selectedOrder.value.id })
                        : '',
                    onClose: _cache[9] || (_cache[9] = ($event) => (orderTrackingModalIsOpen.value = false))
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createVNode)(OrderTrackingInfos_vue_1.default, {
                            "unique-tracking-data": (0, vue_2.unref)(uniqueTrackingData),
                            "tracking-data-loading": trackingDataLoading.value
                        }, null, 8, ["unique-tracking-data", "tracking-data-loading"])
                    ]),
                    _: 1
                }, 8, ["isOpen", "title"])
            ]));
        };
    }
});
